<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-lg-flex">
      <dark-Toggler class="d-lg-block darktoggler" />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">{{ data.name }}</p>
            <span
              class="user-status"
              style="font-family: Arial, sans-serif;margin-top:.3rem"
              >{{ data.company_name }}</span
            >
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="require('@/assets/images/touxiang.jpg')"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
          <feather-icon size="16" icon="PowerIcon" class="mr-50" />
          <span> 退出系统</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
} from "bootstrap-vue";
import DarkToggler from "@core/layouts/components/app-navbar/components/DarkToggler.vue";

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    // Navbar Components
    DarkToggler,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      data: {
        name: "未知用户",
        company_name: "-",
      },
    };
  },
  mounted() {
    var token = this.$getToken();
    if (token && token.profile) {
      this.data = token.profile;
    }
  },
  methods: {
    logout() {
      // this.$swal({
      //   title: "提示",
      //   text: "来都来了，别想走了！",
      //   customClass: {
      //     confirmButton: "btn btn-primary",
      //   },
      //   confirmButtonText: "确定",
      //   buttonsStyling: false,
      // });
      this.$removeToken();
      this.$router.push({
        name: "Login",
      });

    },
  },
};
</script>
